import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full flex"
}
const _hoisted_2 = {
  key: 1,
  class: "h-full"
}
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "flex sticky py-4 top-0 left-0 w-full bg-brand-black/50 backdrop-blur z-50 px-4 space-x-2"
}
const _hoisted_5 = {
  key: 0,
  class: "flex w-full space-x-2"
}
const _hoisted_6 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_9 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = {
  key: 1,
  class: "flex w-full space-x-2"
}
const _hoisted_11 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_12 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_14 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_16 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = {
  key: 2,
  class: "flex"
}
const _hoisted_18 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_19 = {
  key: 0,
  class: "flex my-auto"
}
const _hoisted_20 = { class: "w-4 h-4 bg-brand-lime flex rounded-full my-auto" }
const _hoisted_21 = { class: "m-auto text-xxs text-brand-black font-medium leading-normal" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = { class: "flex flex-col space-y-6 p-4 pb-8" }
const _hoisted_25 = { class: "flex flex-col w-full space-y-0.5" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "flex flex-col w-full space-y-0.5" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "flex flex-col w-full space-y-0.5" }
const _hoisted_30 = { class: "text-brand-light-gray text-lg post-content leading-tight" }
const _hoisted_31 = { class: "flex flex-col" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col px-4 py-3 space-y-5"
}
const _hoisted_33 = { class: "flex text-brand-light-gray text-lg" }
const _hoisted_34 = { class: "flex flex-col space-y-3" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "flex flex-col w-full my-auto" }
const _hoisted_38 = { class: "flex space-x-2" }
const _hoisted_39 = { class: "text-white font-medium my-auto line-clamp-1" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "flex flex-col px-4 py-3 space-y-5"
}
const _hoisted_43 = { class: "flex text-brand-light-gray text-lg" }
const _hoisted_44 = { class: "flex flex-col space-y-3" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "flex w-full space-x-3" }
const _hoisted_47 = { class: "flex" }
const _hoisted_48 = { class: "flex flex-col w-full my-auto" }
const _hoisted_49 = { class: "flex space-x-2" }
const _hoisted_50 = { class: "text-white font-medium my-auto line-clamp-1" }
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = {
  key: 1,
  class: "flex flex-col px-4 py-4 space-y-5"
}
const _hoisted_53 = { class: "flex flex-col" }
const _hoisted_54 = {
  key: 0,
  class: "flex flex-col px-4 py-3 space-y-5"
}
const _hoisted_55 = { class: "flex flex-col space-y-3" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = { class: "flex flex-col w-full my-auto" }
const _hoisted_59 = { class: "flex space-x-2" }
const _hoisted_60 = { class: "text-white font-medium my-auto line-clamp-1" }
const _hoisted_61 = { class: "flex" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 1,
  class: "flex flex-col px-4 py-4 space-y-5"
}

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLabel,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar, isPlatform,
  modalController,
  toastController,
  useIonRouter,
} from '@ionic/vue';
import {computed, onMounted, onUnmounted, Ref, ref} from 'vue';
import {useRoute} from "vue-router";
import ApiService from "@/services/api/apiService";
import * as sanitizeHtml from 'sanitize-html';

import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {EventInterface} from "@/interfaces/EventInterface";
import EventCard from "@/components/EventCard.vue";
import {EventPrivacy} from "@/definitions/EventPrivacy";
import UserAvatar from "@/components/UserAvatar.vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {usePremium} from "@/composables/usePremium";
import EventInviteRequestContextMenu from "@/views/events/EventInviteRequestContextMenu.vue";
import * as events from "events";
import ShareSheet from "@/views/common/ShareSheet.vue";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {useVerification} from "@/composables/useVerification";
import FeedNewPostPage from "@/views/feed/FeedNewPostPage.vue";
import EventViewChatPage from "@/views/events/EventViewChatPage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventPage',
  setup(__props) {

const loading = ref(true)
const ionRouter = useIonRouter()
const route = useRoute()
const observable = ref()

const authUser = ref()

const eventId = ref()
const event: Ref<EventInterface | undefined> = ref()

const getData = async () => {
  event.value = await ApiService.Events().get(eventId.value)
}

const goBack = async () => {
  await ionRouter.back()
}


onMounted(async () => {

  try {
    eventId.value = route.params.eventId
    await getData()
    authUser.value = await ApiService.User().authUser()
  } catch (e: any) {
    if (e.status === 404) {

      const alert = await alertController.create({
        header: 'Not available',
        subHeader: 'The requested event is no longer available.',
        buttons: [
          {
            text: 'Ok',
            handler: async () => {
              alertController.dismiss()
              await goBack()
            }
          }
        ]
      })
      await alert.present()

    }
  }

  observable.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.EventsChanged) await getData()
  })

  loading.value = false

})

onUnmounted(() => {
  observable.value.unsubscribe()
})

const pullToRefresh = async (ev: any) => {
  await getData();
  ev.target.complete()
}

const tab = ref('details')
const tabChanged = async (event: any) => {

  tab.value = event.detail.value
  if (!authUser.value.subscribed) {
    tab.value = 'details'
    await usePremium().presentPayWall({
      text: `Upgrade to see who's on the guest list.`,
    })
  }
}

const isOrganiser = computed(() => {
  return authUser.value.id === event.value?.organiser.id
})

const viewProfile = async (user: UserBasicInformationInterface) => {

  ionRouter.navigate({
    name: 'PineappleEventsUserProfile',
    params: {
      userId: user.id
    }
  }, 'forward', 'push')

}

const attendBusy = ref(false)
const interestBusy = ref(false)
const requestBusy = ref(false)

const attend = async () => {
  if (attendBusy.value) return

  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (authUser.value && !authUser.value.id_verified) return await useVerification().presentVerificationRequired('You must be verified to set your profile as attending this event.')

  try {

    attendBusy.value = true
    if (!event.value?.is_attending) {

      // const sheet = await modalController.create({
      //   breakpoints: [0, 1],
      //   initialBreakpoint: 1,
      //   component: ShareSheet,
      //   mode: 'ios',
      //   componentProps: {
      //     title: 'Attending',
      //     description: `Publicly post this event to the feed with or without a comment to tell others you'll be attending this event.`,
      //     placeholder: `e.g. I can't wait for this event, who's going?`,
      //     button: 'Share to Feed'
      //   }
      // })
      // await sheet.present()
      // let share = (await sheet.onWillDismiss()).data
      // if (share === undefined) return attendBusy.value = false
      // if (share === null) share = undefined

      event.value = await ApiService.Events().attending(event.value?.id as number, null)

    } else {
      event.value = await ApiService.Events().notAttending(event.value.id)
    }

    Observable.emit(ObservableEvent.PullToRefreshMyTickets)
    attendBusy.value = false
  } catch (e: any) {
    attendBusy.value = false
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}

const showInterest = async () => {
  if (interestBusy.value) return

  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (authUser.value && !authUser.value.id_verified) return await useVerification().presentVerificationRequired('You must be verified to show interest in this event.')

  interestBusy.value = true
  try {
    if (event.value?.is_interested) {
      event.value = await ApiService.Events().notInterested(event.value.id)
    } else {

      // const sheet = await modalController.create({
      //   breakpoints: [0, 1],
      //   initialBreakpoint: 1,
      //   component: ShareSheet,
      //   mode: 'ios',
      //   componentProps: {
      //     title: 'Interested',
      //     description: `Publicly post this event to the feed with or without a comment to tell others you're interested in this event.`,
      //     placeholder: `e.g. Interested in this event, who's going?`,
      //     button: 'Share to Feed'
      //   }
      // })
      // await sheet.present()
      // let share = (await sheet.onWillDismiss()).data
      // if (share === undefined) return attendBusy.value = false
      // if (share === null) share = undefined

      event.value = await ApiService.Events().interested(event.value?.id as number, null)
    }
    Observable.emit(ObservableEvent.PullToRefreshMyTickets)
    interestBusy.value = false
  } catch (e: any) {
    interestBusy.value = false
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}

const requestInvite = async () => {
  if (requestBusy.value) return

  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (authUser.value && !authUser.value.id_verified) return await useVerification().presentVerificationRequired('You must be verified to request invites to events.')

  requestBusy.value = true
  try {
    if (event.value?.has_requested_invite) {
      event.value = await ApiService.Events().cancelRequestInvite(event.value.id)
    } else {
      event.value = await ApiService.Events().requestInvite(event.value?.id as number)
    }
    Observable.emit(ObservableEvent.PullToRefreshMyTickets)
    requestBusy.value = false
  } catch (e: any) {
    requestBusy.value = false
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }
}

const contextMenu = async (user: UserBasicInformationInterface) => {

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: EventInviteRequestContextMenu,
    componentProps: {
      event: event.value,
      user
    },
    mode: 'ios'
  })

  await sheet.present()

}

const notAttending = async (e: EventInterface) => {

  if (requestBusy.value) return

  const alert = await alertController.create({
    header: 'Guest List',
    message: 'Are you sure you want to remove yourself from the guest list?',
    buttons: [
      {
        text: 'Cancel'
      },
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          requestBusy.value = true
          try {
            event.value = await ApiService.Events().notAttending(e.id)
            Observable.emit(ObservableEvent.EventsChanged)
            requestBusy.value = false
          } catch (e: any) {
            const toast = await toastController.create({
              message: e.data.message,
              duration: 3000,
              position: 'bottom',
              color: 'danger'
            });
            await toast.present();
            requestBusy.value = false
          }
        }
      },
    ]
  })

  await alert.present()

}

const eventChat = async () => {

  const modal = await modalController.create({
    component: EventViewChatPage,
    mode: 'ios',
    componentProps: {
      eventId: eventId.value,
      canViewEvent: false
    },
    presentingElement: document.getElementById('tabs') as HTMLElement,
  })
  await modal.present()

}


return (_ctx: any,_cache: any) => {
  const _component_photo_consumer = _resolveComponent("photo-consumer")!
  const _component_photo_provider = _resolveComponent("photo-provider")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                class: "flex",
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "text-2xl text-white font-medium" }, null, -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: eventChat,
                    class: "flex bg-white space-x-2 h-9 rounded-full px-4"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "font-medium text-sm my-auto" }, "Chat", -1),
                    _createElementVNode("div", { class: "flex my-auto" }, [
                      _createElementVNode("svg", {
                        class: "fill-current mb-1 h-4",
                        viewBox: "0 0 25 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M2.70847 5.66957C2.99865 3.98488 4.33773 2.74648 6.02778 2.48932C7.64711 2.24293 9.86859 2 12.333 2C14.7974 2 17.0189 2.24293 18.6382 2.48932C20.3283 2.74648 21.6674 3.98488 21.9576 5.66957C22.1598 6.84372 22.333 8.33525 22.333 10C22.333 11.6647 22.1598 13.1563 21.9576 14.3304C21.6674 16.0151 20.3283 17.2535 18.6382 17.5107C17.1568 17.7361 15.1714 17.9586 12.9571 17.9949L6.84173 21.6085C6.17512 22.0024 5.33301 21.5219 5.33301 20.7476V17.344C3.97957 16.8939 2.95757 15.7766 2.70847 14.3304C2.50622 13.1563 2.33301 11.6647 2.33301 10C2.33301 8.33525 2.50622 6.84372 2.70847 5.66957ZM6.33301 8C6.33301 7.44772 6.78072 7 7.33301 7H17.333C17.8853 7 18.333 7.44772 18.333 8C18.333 8.55228 17.8853 9 17.333 9H7.33301C6.78072 9 6.33301 8.55228 6.33301 8ZM6.33301 12C6.33301 11.4477 6.78072 11 7.33301 11H11.333C11.8853 11 12.333 11.4477 12.333 12C12.333 12.5523 11.8853 13 11.333 13H7.33301C6.78072 13 6.33301 12.5523 6.33301 12Z"
                        })
                      ])
                    ], -1)
                  ]))])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { id: "ionContent" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            class: "safe-area-top top-4 lef-0 text-white z-50 relative",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (pullToRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-icon": "crescent",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "m-auto flex" }, [
                  _createElementVNode("svg", {
                    class: "animate-spin h-10 w-10 text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (!loading.value && event.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_photo_provider, { class: "relative w-full z-40" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_photo_consumer, {
                      class: "w-full",
                      src: event.value.photo_url
                    }, {
                      default: _withCtx(() => [
                        _createVNode(EventCard, {
                          class: "w-full",
                          event: event.value
                        }, null, 8, ["event"])
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  (!isOrganiser.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (event.value.visibility === _unref(EventPrivacy).Public || event.value.visibility === _unref(EventPrivacy).InnerCircle)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              ((event.value.capacity === 0 || event.value.is_attending) || event.value.capacity_remaining > 0 && event.value.capacity > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: attend,
                                    class: _normalizeClass([{
                      'opacity-30': event.value.is_attending
                   }, "w-1/2 border-2 border-brand-lime bg-brand-lime font-medium rounded-full text-brand-black px-5 h-10 flex flex-grow"])
                                  }, [
                                    (!attendBusy.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(event.value.is_attending ? 'Attending' : 'Attend'), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                                          _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                          }, null, -1),
                                          _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          }, null, -1)
                                        ]))]))
                                  ], 2))
                                : _createCommentVNode("", true),
                              (!event.value.is_attending)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: showInterest,
                                    class: _normalizeClass([{
                      'opacity-30': event.value.is_interested
                   }, "w-1/2 border-2 border-brand-dark-gray bg-brand-dark-gray font-medium rounded-full text-white px-5 h-10 flex flex-grow"])
                                  }, [
                                    (!interestBusy.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(event.value.is_interested ? 'Interested' : 'Show interest'), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                                          _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                          }, null, -1),
                                          _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          }, null, -1)
                                        ]))]))
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (event.value.visibility === _unref(EventPrivacy).InviteOnly)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (!event.value.is_attending || (event.value.capacity_remaining > 0 && event.value.capacity > 0) || event.value.has_requested_invite)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: requestInvite,
                                    class: _normalizeClass([{
                      'opacity-30': event.value.has_requested_invite
                   }, "border-2 w-1/2 border-brand-lime bg-brand-lime font-medium rounded-full text-brand-black px-5 h-12 flex flex-grow"])
                                  }, [
                                    (!requestBusy.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(event.value.has_requested_invite ? 'Invite requested' : 'Request invite'), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                                          _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                          }, null, -1),
                                          _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          }, null, -1)
                                        ]))]))
                                  ], 2))
                                : _createCommentVNode("", true),
                              (event.value.is_attending)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (notAttending(event.value))),
                                    class: "border-2 opacity-30 border-brand-lime bg-brand-lime font-medium rounded-full text-brand-black px-5 h-12 flex flex-grow"
                                  }, [
                                    (!requestBusy.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Attending"))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[9] || (_cache[9] = [
                                          _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                          }, null, -1),
                                          _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          }, null, -1)
                                        ]))]))
                                  ]))
                                : _createCommentVNode("", true),
                              (!event.value.is_attending)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    onClick: showInterest,
                                    class: _normalizeClass([{
                      'opacity-30': event.value.is_interested
                   }, "w-1/2 border-2 border-brand-dark-gray bg-brand-dark-gray font-medium rounded-full text-white px-5 h-10 flex flex-grow"])
                                  }, [
                                    (!interestBusy.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(event.value.is_interested ? 'Interested' : 'Show interest'), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[10] || (_cache[10] = [
                                          _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                          }, null, -1),
                                          _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          }, null, -1)
                                        ]))]))
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        false
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("div", { class: "bg-brand-dark-gray font-medium rounded-full text-white h-12 w-12 flex mt-auto" }, [
                                _createElementVNode("svg", {
                                  class: "h-5 fill-current m-auto",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 128 512"
                                }, [
                                  _createElementVNode("path", { d: "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z" })
                                ])
                              ], -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (isOrganiser.value || event.value.public_guest_list)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_unref(IonSegment), {
                          onIonChange: tabChanged,
                          value: tab.value,
                          class: "relative z-20 backdrop-blur-2xl bg-opacity-40 w-ful mb-2",
                          "swipe-gesture": false,
                          mode: "ios"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSegmentButton), { value: "details" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode(" Details ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSegmentButton), { value: "guest-list" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode(" Guest List ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (isOrganiser.value && event.value.visibility === _unref(EventPrivacy).InviteOnly)
                              ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                                  key: 0,
                                  value: "pending"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { class: "text-lg font-medium flex space-x-2" }, {
                                      default: _withCtx(() => [
                                        _cache[14] || (_cache[14] = _createElementVNode("div", null, " Pending ", -1)),
                                        (event.value.requested.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                              _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, _toDisplayString(event.value.requested.length), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
                    [_vShow, tab.value==='chat']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "About", -1)),
                        _createElementVNode("div", {
                          class: "text-brand-light-gray text-lg post-content whitespace-pre-wrap leading-tight",
                          innerHTML: sanitizeHtml(event.value.description)
                        }, null, 8, _hoisted_26)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Rules", -1)),
                        _createElementVNode("div", {
                          class: "text-brand-light-gray text-lg post-content whitespace-pre-wrap leading-tight",
                          innerHTML: sanitizeHtml(event.value.rules)
                        }, null, 8, _hoisted_28)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Location", -1)),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(event.value.location), 1)
                      ])
                    ])
                  ], 512), [
                    [_vShow, tab.value==='details']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_31, [
                    (event.value.attending.length || event.value.interested.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (event.value.attending.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(event.value.attending.length) + " " + _toDisplayString(event.value.attending.length < 2 ? 'person is' : 'people are') + " attending this event ", 1),
                                _createElementVNode("div", _hoisted_34, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.attending, (user, userIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex justify-between",
                                      key: userIndex
                                    }, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (viewProfile(user)),
                                        class: "flex w-full space-x-3"
                                      }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createVNode(UserAvatar, {
                                            size: 10,
                                            user: user
                                          }, null, 8, ["user"])
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                          _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, _toDisplayString(user.name), 1),
                                            _createElementVNode("div", _hoisted_40, [
                                              _createVNode(UserVerificationCheck, {
                                                class: "h-4",
                                                user: user
                                              }, null, 8, ["user"])
                                            ])
                                          ])
                                        ])
                                      ], 8, _hoisted_35),
                                      (isOrganiser.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            onClick: ($event: any) => (contextMenu(user)),
                                            class: "flex pl-3 py-2.5 my-auto"
                                          }, [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("svg", {
                                              class: "my-auto",
                                              width: "24",
                                              height: "25",
                                              viewBox: "0 0 24 25",
                                              fill: "none",
                                              xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                              _createElementVNode("path", {
                                                d: "M5.52035 14.5583C6.71329 14.5583 7.68035 13.5912 7.68035 12.3983C7.68035 11.2053 6.71329 10.2383 5.52035 10.2383C4.32742 10.2383 3.36035 11.2053 3.36035 12.3983C3.36035 13.5912 4.32742 14.5583 5.52035 14.5583Z",
                                                fill: "#A5A7AF"
                                              }),
                                              _createElementVNode("path", {
                                                d: "M12.0008 14.5583C13.1938 14.5583 14.1608 13.5912 14.1608 12.3983C14.1608 11.2053 13.1938 10.2383 12.0008 10.2383C10.8079 10.2383 9.84082 11.2053 9.84082 12.3983C9.84082 13.5912 10.8079 14.5583 12.0008 14.5583Z",
                                                fill: "#A5A7AF"
                                              }),
                                              _createElementVNode("path", {
                                                d: "M18.4803 14.5583C19.6732 14.5583 20.6403 13.5912 20.6403 12.3983C20.6403 11.2053 19.6732 10.2383 18.4803 10.2383C17.2874 10.2383 16.3203 11.2053 16.3203 12.3983C16.3203 13.5912 17.2874 14.5583 18.4803 14.5583Z",
                                                fill: "#A5A7AF"
                                              })
                                            ], -1)
                                          ]))], 8, _hoisted_41))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (event.value.interested.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, _toDisplayString(event.value.interested.length) + " " + _toDisplayString(event.value.interested.length < 2 ? 'person is' : 'people are') + " interested this event ", 1),
                                _createElementVNode("div", _hoisted_44, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.interested, (user, userIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      onClick: ($event: any) => (viewProfile(user)),
                                      class: "flex",
                                      key: userIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          _createVNode(UserAvatar, {
                                            size: 10,
                                            user: user
                                          }, null, 8, ["user"])
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                          _createElementVNode("div", _hoisted_49, [
                                            _createElementVNode("div", _hoisted_50, _toDisplayString(user.name), 1),
                                            _createElementVNode("div", _hoisted_51, [
                                              _createVNode(UserVerificationCheck, {
                                                class: "h-4",
                                                user: user
                                              }, null, 8, ["user"])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ], 8, _hoisted_45))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("div", { class: "p-3 bg-brand-dark-gray text-brand-light-gray rounded-lg w-full text-center" }, " Guest list information will be available soon. ", -1)
                        ]))]))
                  ], 512), [
                    [_vShow, tab.value==='guest-list']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_53, [
                    (event.value.requested.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (event.value.requested.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex text-brand-light-gray text-lg" }, "The following people would like to attend your event. ", -1)),
                                _createElementVNode("div", _hoisted_55, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.requested, (user, userIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex justify-between",
                                      key: userIndex
                                    }, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (viewProfile(user)),
                                        class: "flex w-full space-x-3"
                                      }, [
                                        _createElementVNode("div", _hoisted_57, [
                                          _createVNode(UserAvatar, {
                                            size: 10,
                                            user: user
                                          }, null, 8, ["user"])
                                        ]),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("div", _hoisted_60, _toDisplayString(user.name), 1),
                                            _createElementVNode("div", _hoisted_61, [
                                              _createVNode(UserVerificationCheck, {
                                                class: "h-4",
                                                user: user
                                              }, null, 8, ["user"])
                                            ])
                                          ])
                                        ])
                                      ], 8, _hoisted_56),
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (contextMenu(user)),
                                        class: "flex pl-3 py-2.5 my-auto"
                                      }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("svg", {
                                          class: "my-auto",
                                          width: "24",
                                          height: "25",
                                          viewBox: "0 0 24 25",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }, [
                                          _createElementVNode("path", {
                                            d: "M5.52035 14.5583C6.71329 14.5583 7.68035 13.5912 7.68035 12.3983C7.68035 11.2053 6.71329 10.2383 5.52035 10.2383C4.32742 10.2383 3.36035 11.2053 3.36035 12.3983C3.36035 13.5912 4.32742 14.5583 5.52035 14.5583Z",
                                            fill: "#A5A7AF"
                                          }),
                                          _createElementVNode("path", {
                                            d: "M12.0008 14.5583C13.1938 14.5583 14.1608 13.5912 14.1608 12.3983C14.1608 11.2053 13.1938 10.2383 12.0008 10.2383C10.8079 10.2383 9.84082 11.2053 9.84082 12.3983C9.84082 13.5912 10.8079 14.5583 12.0008 14.5583Z",
                                            fill: "#A5A7AF"
                                          }),
                                          _createElementVNode("path", {
                                            d: "M18.4803 14.5583C19.6732 14.5583 20.6403 13.5912 20.6403 12.3983C20.6403 11.2053 19.6732 10.2383 18.4803 10.2383C17.2874 10.2383 16.3203 11.2053 16.3203 12.3983C16.3203 13.5912 17.2874 14.5583 18.4803 14.5583Z",
                                            fill: "#A5A7AF"
                                          })
                                        ], -1)
                                      ]))], 8, _hoisted_62)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_63, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("div", { class: "p-3 bg-brand-dark-gray text-brand-light-gray rounded-lg w-full text-center" }, " There's no outstanding invite requests right now. ", -1)
                        ]))]))
                  ], 512), [
                    [_vShow, tab.value==='pending']
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})